const version = "1.11.0"
const releaseDate = "2021-05-24"
export {version, releaseDate}
